import { inject, Injectable } from '@angular/core';
import { DURATION_TOKENS } from '@lx/shared/i18n';
import { DurationUnit, DurationUnitEnum } from '@lx/shared/data-access/types';

@Injectable({
  providedIn: 'root',
})
export class DurationUnitsService {
  private readonly durationUnitMap: Record<'singular' | 'plural', Record<DurationUnit, string>> = inject(DURATION_TOKENS);

  getPerDurationText(durationUnit: DurationUnit = 'WEEKS', extraLesson = false): string {
    switch (durationUnit) {
      case DurationUnitEnum.EACH:
        return extraLesson ? $localize`per extra lesson` : $localize`per lesson`;
      case DurationUnitEnum.HOURS:
        return extraLesson ? $localize`per extra hour` : $localize`per hour`;
      case DurationUnitEnum.DAYS:
        return extraLesson ? $localize`per extra day` : $localize`per day`;
      case DurationUnitEnum.MONTH:
        return extraLesson ? $localize`per extra month` : $localize`per month`;
      case DurationUnitEnum.YEARS:
        return extraLesson ? $localize`per extra year` : $localize`per year`;
      case DurationUnitEnum.WEEKS:
      default:
        return extraLesson ? $localize`per extra week` : $localize`per week`;
    }
  }

  getDurationPluralText(durationUnit: DurationUnit = DurationUnitEnum.WEEKS) {
    return this.durationUnitMap.plural[durationUnit] ?? '';
  }
}
